import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    background: {
      default: '#f5f5f5',
    },
    text: {
      primary: '#222',
    },
  },
  typography: {
    fontFamily: '"Space Mono", monospace',
    qcHeading: {
      color: '#222',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 500,
    },
    qcControl: {
      color: '#222',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 500,
    },
  },
});

export default theme;
